"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class ContentNode {
    constructor(type, minLength = 1) {
        this.type = type;
        this.minLength = minLength;
        this.content = [];
    }
    toJSON() {
        if (this.content.length < this.minLength) {
            throw new Error(`There must be at least ${this.minLength} content elements`);
        }
        return {
            type: this.type,
            content: this.content.map(node => node.toJSON())
        };
    }
    add(node) {
        if (!node) {
            throw new Error('Illegal value');
        }
        this.content.push(node);
        return node;
    }
}
exports.ContentNode = ContentNode;
class TopLevelNode {
}
exports.TopLevelNode = TopLevelNode;
class InlineNode {
}
exports.InlineNode = InlineNode;
//# sourceMappingURL=index.js.map